import { useState } from "react";
import PropTypes from "prop-types";
import { Icon, Input } from "components/atoms";
import { FormControl } from "components/template";
import classNames from "classnames";

const InputControl = ({
  errors,
  inputProps: { className: inptClass = "", ...inputProps } = { },
  label,
  labelProps: { className: lblClass = "", ...labelProps } = { },
  name,
  orientation = "horizontal",
  showErrors = true,
  value,
  ...props
}) => {
  const [showValue, setShowValue] = useState(false);

  const inputClass = classNames("min-w-min", {
    [inptClass]: inptClass,
  });

  const labelClass =  classNames({
    [lblClass]: lblClass,
    "flex-1 my-auto": ["radio", "checkbox"].includes(inputProps?.type)
  });

  const wrapClass = classNames("h-9", {
    "flex-none": ["radio", "checkbox"].includes(inputProps?.type)
  });

  return (
    <FormControl
      errors={errors}
      label={label}
      labelProps={{
        ...labelProps,
        className: labelClass,
      }}
      orientation={orientation}
      reverse={["radio", "checkbox"].includes(inputProps?.type)}
      showErrors={showErrors}
      wrapClass={wrapClass}
      {...props}
    >
      <Input
        className={inputClass}
        name={name}
        errors={errors}
        {...inputProps}
        type={inputProps?.type !== "password" ? inputProps?.type : (showValue ? "text" : "password")}
        value={value}
      />
      {inputProps?.type === "password" && 
        <div
          className="absolute right-4 top-3 bg-gray-100 cursor-pointer rounded-full"
          onClick={() => setShowValue((v) => !v)}
        >
          <Icon icon={showValue ? "eyeSlash" : "eye"} />
        </div>
      }
    </FormControl>
  );
};

InputControl.propTypes = {
  labelProps: PropTypes.object,
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  showErrors: PropTypes.bool
};

export default InputControl;
